import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_8070_183627)">
      <path
        d="M0.702026 8.91211V9.72717C0.702026 10.1595 0.873772 10.5742 1.17949 10.8799C1.48521 11.1856 1.89984 11.3574 2.33218 11.3574H9.66794C10.1003 11.3574 10.5149 11.1856 10.8206 10.8799C11.1263 10.5742 11.2981 10.1595 11.2981 9.72717V8.91211"
        stroke="#CCCCCC"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.83167 3.45508C8.27629 2.43294 7.44911 1.50145 6.3835 0.857207C6.1475 0.714527 5.85232 0.714536 5.61633 0.857233C4.55077 1.50152 3.7236 2.43296 3.1682 3.45508"
        stroke="#CCCCCC"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6 0.857281L6 7.94629" stroke="#CCCCCC" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_8070_183627">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const UploadIcon = memo(ForwardRef);
export default UploadIcon;
